import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { func, object } from 'prop-types';
import { Button as AvonButton } from '@avon/component-library';
import closeIcon from '../assets/closeIcon.svg';
import { isMobile } from '../../../utils/getDeviceType';

const useStyles = makeStyles(() => ({
  wrapper: e => (e.isMobile ? {
    padding: '40px 16px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& img': {
      width: 64,
      height: 64,
    },
  } : {
    padding: '60px 60px 53px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& img': {
      width: 96,
      height: 96,
    },
  }),
  title: e => (e.isMobile ? {
    fontFamily: 'Montserrat',
    fontWeight: 500,
    fontSize: '22px',
    lineHeight: '30px',
    textAlign: 'center',
    color: '#851168',
    margin: '30px 0 12px',
  } : {
    fontFamily: 'Montserrat-Light',
    fontSize: '42px',
    lineHeight: '54px',
    textAlign: 'center',
    color: '#851168',
    margin: '12px 0 24px',
  }),
  desc: e => (e.isMobile ? {
    fontFamily: 'Montserrat',
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'center',
    color: '#707677',
  } : {
    fontFamily: 'Montserrat',
    fontSize: '18px',
    lineHeight: '26px',
    textAlign: 'center',
    color: '#546264',
  }),
}));

const CloseDetail = ({
  setclickId,
  notifycationDetail: { contentMap, category },
  snsInfo: { button, info = {} },
}) => {
  const classes = useStyles({ language: 'not ar', isMobile: isMobile() });

  return (
    <Box className={classes.wrapper}>
      <img src={closeIcon} alt="success-icon" />
      <Box className={classes.title}>{info[category]}</Box>
      {
        contentMap && contentMap.content0 && (
          <Box className={classes.desc}>
            {contentMap.content0}
          </Box>
        )
      }
      {
        contentMap && contentMap.content1 && (
          <Box className={classes.desc}>
            {contentMap.content1}
          </Box>
        )
      }
      {
        contentMap && contentMap.content2 && (
          <Box className={classes.desc}>
            {contentMap.content2}
          </Box>
        )
      }
      <Box style={{ width: '100%', marginTop: 42 }}>
        <AvonButton priority="secondary" onClick={() => setclickId('')}>{button.close}</AvonButton>
      </Box>
    </Box>
  );
};

CloseDetail.propTypes = {
  notifycationDetail: object,
  setclickId: func,
  snsInfo: object,
};

export default CloseDetail;
